<template>
  <div class="amap-page-container">
    <div class="lamp-search">
      <i class="el-icon-search"></i>
      <el-select
        v-model="selectedLamp"
        placeholder="输入路灯名称"
        filterable
        clearable
        @change="selectChange"
      >
        <el-option
          v-for="lamp in markers"
          :key="lamp.lamp_id"
          :label="lamp.name"
          :value="lamp.lamp_id"
        >
        </el-option>
      </el-select>
    </div>
    <el-amap
      ref="gmap"
      vid="gmapDemo"
      :center="center"
      :zoom="zoom"
      class="gmap-demo"
      mapStyle="amap://styles/light"
    >
      <el-amap-marker
        v-for="(marker, index) in markers"
        :key="index"
        :position="[Number(marker.longitude), Number(marker.latitude)]"
        :icon="marker.url"
        :offset="[-30, -70]"
        :events="{ click: () => markerClick(marker) }"
        :vid="index"
        :title="marker.name"
      >
      </el-amap-marker>
      <el-amap-info-window
        :position="currentWindow.position"
        :visible="currentWindow.visible"
        :events="{ close: () => close() }"
        closeWhenClickMap="true"
      >
        <div>
          <h3 class="info-title" :title="lampInfo.name">{{ lampInfo.name }}</h3>
          <div class="info-content">
            <div v-html="getGasValue(lampInfo.sb)"></div>
          </div>
          <div class="info-controls">
            <button
              class="btn-lamp-control"
              data-text="路灯控制"
              @click="$router.push('/light/lightList')">
            ></button>
            <button
              v-if="lampInfo.camera_list.length > 0"
              class="btn-video-preview"
              data-text="摄像头"
              @click="videoPreview(lampInfo.lamp_id)"
            ></button>
          </div>
        </div>
      </el-amap-info-window>
    </el-amap>
    <!-- 查看监控 -->
    <div
      class="box_control_bg"
      v-if="videoData.dialogVisible"
      @click="closeVideo"
    ></div>
    <div class="box_control" v-if="videoData.dialogVisible">
      <div class="box_head">
        <span class="box_title">查看路灯监控</span>
        <div class="box_close" @click="closeVideo">
          <i class="el-icon-close"></i>
        </div>
      </div>
      <div class="box_body">
        <video-mini-control
          ref="video_con"
          :deviceSerial="videoData.ysyNumber"
          :accessToken="accessToken"
        ></video-mini-control>
      </div>
    </div>
  </div>
</template>

<script>
import lightListApi from "@/api/light/lightList";
import videoMiniControl from "@/components/video/VideoMiniControl";
import store from "@/store";
export default {
  name: "Amap",
  components: {
    videoMiniControl,
  },
  data() {
    return {
      selectedLamp: "",
      zoom: 18,
      center: store.state.user.account.center,
      markers: [],
      currentWindow: {
        position: store.state.user.account.center,
        visible: false,
      },
      lampInfo: {
        name: "",
        lamp_id: "",
        stg_id: "",
        stg_name: "",
        light: "",
        ms: "",
        sb: [],
        camera_list: [],
      },
      pageInfo: {
        page: 1,
        pageSize: 500,
      },
      videoData: {
        ysyNumber: "",
        dialogVisible: false,
      },
      accessToken: ''
    };
  },
  methods: {
    getGasValue(items) {
      if(items.length<1){
        return
      }
      let gas_data = [
        "北风",
        "东北风",
        "东风",
        "东南风",
        "南风",
        "西南风",
        "西风",
        "西北风",
      ];
      let itemValue = "";
      for (let i in items) {
        if (items[i].sb_tye == 8) {
          itemValue +=
            items[i].name + "：" + gas_data[items[i].value] + "<br/>";
        } else {
          itemValue += items[i].name + "：" + items[i].value + "<br/>";
        }
      }
      return itemValue;
    },
    selectChange(value) {
      if (value) {
        //根据Id获取路灯信息
        lightListApi.lightInfo(value).then((res) => {
          if (res.data.code === 1000) {
            let resData = res.data.data;
            this.markerClick(resData);
          }
        });
      } else {
        return value;
      }
    },
    getLampList() {
      lightListApi.lightList(this.pageInfo).then((res) => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          if(this.$store.state.user.name=='FORIDO'){
            this.zoom=5
          }
          this.markers = resData.list;
        }
      });
    },
    markerClick(marker) {
      //console.log("marker", marker);
      this.lampInfo = marker;
      this.currentWindow.position = [Number(marker.longitude), Number(marker.latitude)];
      this.currentWindow.visible = true;
      setTimeout(function () {
        this.center = [Number(marker.longitude), Number(marker.latitude)];
      }, 200);
    },
    close() {
      this.currentWindow.visible = false;
      this.videoData.dialogVisible = false;
    },
    videoPreview(canid) {
      // 打开视频
      lightListApi.lightInfo(canid).then((res) => {
        if (res.data.code === 1000) {
          this.videoData.dialogVisible = true;
          this.videoData.ysyNumber = res.data.data.camera_list[0];
        }
      });
    },
    closeVideo() {
      // 关闭视频
      this.videoData.title = "";
      this.videoData.ysyNumber = "";
      this.videoData.dialogVisible = false;
    },
    videoGetAccessToken() {
      lightListApi.getAccessToken().then((res) => {
        this.accessToken = res.data.accessToken;
      });
    },
  },
  created() {
    this.getLampList();
    this.videoGetAccessToken();
  },
};
</script>

<style lang='less' scoped>
.amap-page-container {
  width:100%;
  height:100%;
  position: relative;
  .lamp-search {
    position: fixed !important;
    top: 1rem;
    left: 50%;
    transform: translate(-50%, 85px);
    transition: transform 0.5s;
    z-index: 200;
  }
  .lamp-search .el-icon-search {
    position: absolute;
    top: 12px;
    left: 12px;
    z-index: 200;
    color: #fff;
  }
  .lamp-search .el-icon-search + .el-select input {
    padding-left: 32px;
  }
  .lamp-search .el-icon-search + .el-select .el-icon-caret-top {
    display: none;
  }
  .gmap-demo {
    height: 100%;
    width: 100%;
    position: relative;
    min-height: 700px;
  }
  .amap-page-container {
    position: fixed;
    top: 60px;
    left: 0;
    right: 0;
    bottom: 0;
  }
  h3.info-title {
    margin: 5px 0 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .info-content {
    margin: 5px 0;
    overflow: hidden;
  }
  .info-content span {
    width: 150px;
    float: left;
  }
  .info-controls {
    overflow-x: auto;
    overflow-y: hidden;
    margin-top: 10px;
    outline: none;
  }
  .info-controls button {
    border: 1px solid rgba(51, 153, 204, 0.5);
    border-radius: 50%;
    background-size: 30px;
    background-position: center;
    background-repeat: no-repeat;
    position: relative;
    width: 50px;
    height: 50px;
    line-height: 1.2em;
    margin: 0 10px 25px 0;
    box-sizing: border-box;
    cursor: pointer;
    float: left;
    font-size: 18px;
    outline: none;
  }
  .info-controls button:after {
    content: attr(data-text);
    display: inline-block;
    font-size: 12px;
    position: absolute;
    top: 55px;
    left: 0;
    right: 0;
    text-align: center;
  }
  .info-controls button.btn-lamp-control {
    background-image: url(../assets/svg/lamp-control.svg);
  }
  .info-controls button.btn-video-preview {
    background-image: url(../assets/svg/video-preview.svg);
  }
  .lamp-search input {
    border: none;
    background-color: rgba(0, 0, 0, 0.6);
    box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.3);
    border-radius: 20px;
    color: rgb(255, 255, 255);
    min-width: 300px;
  }
  .lamp-search input::-webkit-input-placeholder {
    color: white;
  }
  .lamp-search input:focus,
  .lamp-search input:hover {
    border-color: transparent;
    background-color: rgba(0, 0, 0, 0.7);
  }
  .text-wrapper {
    white-space: pre-wrap;
  }

  .el-tree {
    overflow: auto !important;
  }
}
</style>
